import { Component, h } from '@stencil/core';

@Component({
  tag: 'utrecht-icon-parkeren-betalen',
  styleUrl: "../../icon/generated.scss",
  shadow: true,
})
export class UtrechtIconParkerenBetalen {

  render() {
    return (
      <svg viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="1em" width="1em">
  <path d="M35.83 33.5c.31.46.19 1.08-.27 1.39A6.328 6.328 0 0 1 32 36c-1.81 0-3.6-.8-4.96-2.35a8.133 8.133 0 0 1-1.53-2.66h-1.52c-.55 0-1-.45-1-1s.45-1 1-1h1.07a9.55 9.55 0 0 1 0-2h-1.08c-.55 0-1-.45-1-1s.45-1 1-1h1.52c.32-.92.8-1.79 1.43-2.54 2.26-2.69 5.8-3.24 8.61-1.35.46.31.58.93.27 1.39-.31.46-.93.58-1.39.27-1.93-1.3-4.38-.9-5.96.98-.32.38-.57.81-.79 1.26h4.31c.55 0 1 .45 1 1s-.45 1-1 1h-4.93c-.09.66-.09 1.34 0 2h4.92c.55 0 1 .45 1 1s-.45 1-1 1h-4.3c.23.48.5.94.86 1.34 1.6 1.83 3.96 2.19 5.89.89a.999.999 0 0 1 1.39.27ZM21 26c0 .77.29 1.47.77 2-.48.53-.77 1.23-.77 2 0 .35.07.68.18.99H4c-2.21 0-4-1.79-4-4V4c0-2.21 1.79-4 4-4h22c2.21 0 4 1.79 4 4v14.25c-1.74.44-3.35 1.45-4.58 2.92-.47.56-.87 1.17-1.21 1.83H24c-1.65 0-3 1.35-3 3m1-14c0-3.3-2.48-5.98-5.52-5.98H11c-.55 0-1 .45-1 1V24c0 .54.44.98.98.98s.98-.44.98-.98v-6.02h4.52C19.52 17.98 22 15.3 22 12m-5.43-4h-4.61v8h4.61c1.89 0 3.43-1.79 3.43-4s-1.54-4-3.43-4"/>
</svg>

    );
  }
}
